import "../../../../resources/less/Troubadour/LandingPages/SocialStudies/SocialStudies.less";

class SocialStudies {
  constructor() {}
}

$(window).on("load", () => {
  new SocialStudies();
});
